import { Folder } from '@mui/icons-material';
import { Box } from '@mui/material';

export const FolderIcon = () => {
  return (
    <Box
      sx={{
        width: '42px',
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Folder color='action' />
    </Box>
  );
};
